import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EventV2Dto } from 'src/app/api/exa';

@Component({
  selector: 'app-comment-add-dialog',
  templateUrl: './comment-add-dialog.component.html',
  styleUrls: ['./comment-add-dialog.component.scss'],
})
export class CommentAddDialogComponent implements OnInit {
  @Input() username;
  @Input() latitude;
  @Input() longitude;
  @Input() machineId;
  @Input() owner;
  @Input() type;

  time = new Date().getTime();

  comment: string = '';

  constructor(public modalCtrl: ModalController) {}

  ngOnInit() {}

  dismiss() {
    this.modalCtrl.dismiss();
  }

  onClickCancel() {
    this.dismiss();
  }

  onClickSave() {
    const comment: EventV2Dto = {
      data: this.comment,
      employee: this.username,
      latitude: this.latitude,
      longitude: this.longitude,
      machine: this.machineId,
      owner: this.owner,
      time: this.time.toString(),
      type: this.type,
    };
    console.log(comment);
    //poner el evento cuando tenga acceso al backend
    this.dismiss();
  }
}
